import { Pelage } from './pelage';
import { Breed } from './breed';
import { Species } from './species';
import { Gender } from './gender';
import { Weighing } from './weighing';
import { VetConsulting } from './vet-consulting';
import { Guardian } from './guardian';

/**
 * Animal
 */
export class Pet {
    /** ID da entidade no Firebase  */
    uuid: string;

    /** Nome */
    name: string;
    /** Nascimento */
    birthday: any;
    /** Descrição */
    note: string;
    /** Gênero */
    gender: Gender;
    /** Espécie */
    species: Species;
    /** Raça */
    breed: Breed;
    /** Pelagem */
    pelage: Pelage;
    /** Cor do Animal */
    color: string;
    /** Data de Cadastro */
    date: any;
    /** Data de Atualização */
    update: any;

    /** Pesagem, <Array:Firebase> */
    weighing: Array<Weighing>;

    /** Histórico de consultas, <Collection:Firebase> */
    consulting: Array<VetConsulting>;

    /** Tutor */
    guardian: Guardian;

    /** */
    coverPhoto: string;

    /** */
    coverPhotoUrl: string;

    photoUrl: string;

    /**
     * Instanciar um
     * @param init - JSON que represente parcialmente as propriedades da classe
     */
    public constructor(init?: Partial<Pet>) {
        Object.assign(this, init);
    }

    /**
     *
     */
    toFirebase(): object {
        return {
            name: this.name,
            birthday: this.birthday || null,
            note: this.note || null,
            gender: this.gender ? this.gender.toFirebase() : null,
            species: this.species ? this.species.toFirebase() : null,
            breed: this.breed ? this.breed.toFirebase() : null,
            pelage: this.pelage ? this.pelage.toFirebase() : null,
            color: this.color || null,
            guardian: this.guardian ? this.guardian.toFirebase() : null,
        };
    }
}
